"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var i = 0;

var randomId = function randomId() {
  var num = Math.floor(Math.random() * 10000) + 1;
  return "x_".concat(i++, "_").concat(num);
};

var _default = randomId;
exports["default"] = _default;